import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { formationData } from "./FormationsSection.mock";

import "./FormationsSection.scss";
import ListItem from "../DstIcon/ListItem";

const FormationSection = ({
  imageSrc,
  imageTitle,
  imageLink,
  roles,
  textColor,
}: {
  imageSrc: string;
  imageTitle: string;
  imageLink: string;
  roles: { title: string; link: string }[];
  textColor: string;
}) => (
  <Col xs={6} md={4} lg className="px-lg-0 border-end mt-3">
    <Link
      to={imageLink}
      className="formation-sector-link d-block position-relative"
      aria-label={`Découvrir les formations ${imageTitle}`}
    >
      <img src={imageSrc} alt="" className="img-fluid" />
      <div className="white-font position-absolute top-50 start-50 translate-middle l-black text-uppercase">
        {imageTitle}
      </div>
    </Link>
    <ul
      className="list-check xs-semibold mt-3 ps-2"
      style={{ color: textColor }}
    >
      {roles.map((role) => (
        <li key={role.link}>
          <ListItem color={textColor} className="me-2" />
          <Link
            to={role.link}
            className="formation-link text-decoration-none"
            style={{ color: textColor }}
          >
            {role.title}
          </Link>
        </li>
      ))}
    </ul>
  </Col>
);

const FormationsSection = ({ textColor }: { textColor: string }) => (
  <Row className="mt-md-3">
    {formationData.map((data, index) => (
      <FormationSection key={index} {...data} textColor={textColor} />
    ))}
  </Row>
);

export default FormationsSection;
